export const DISCOUNT_TYPES = {
  PERCENTAGE: 1,
  AMOUNT: 2,
} as const;

export const DISCOUNT_TYPES_OPTIONS = [
  { label: "Procent", value: DISCOUNT_TYPES.PERCENTAGE },
  { label: "Kwota", value: DISCOUNT_TYPES.AMOUNT },
];
